import * as Yup from 'yup'

const schema = Yup.object().shape({
  type: Yup.string().required('Tipo é obrigatório'),
  date_lt: Yup.string().required('Data inicial é obrigatório'),
  date_gt: Yup.string().required('Data final é obrigatório'),
})

export default schema
